import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyContactInformation = lazyWithRetry(
  () => import("./ContactInformation"),
);

const ContactInformation = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyContactInformation {...props} />;

export default ContactInformation;
